import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './config/i18n';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import NumerologyPage from './pages/NumerologyPage';
import RelationshipNumerologyPage from './pages/RelationshipNumerologyPage';
import AstroNumerologyPage from './pages/AstroNumerologyPage';
import HealingNumbersPage from './pages/HealingNumbersPage';
import PsychologicalNumerologyPage from './pages/PsychologicalNumerologyPage';
import AnalysisResultPage from './pages/AnalysisResultPage';
import ProfilePage from './pages/ProfilePage';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Navbar />
            <main style={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/numerology" element={<NumerologyPage />} />
                <Route path="/relationship-numerology" element={<RelationshipNumerologyPage />} />
                <Route path="/astro-numerology" element={<AstroNumerologyPage />} />
                <Route path="/healing-numbers" element={<HealingNumbersPage />} />
                <Route path="/psychological-numerology" element={<PsychologicalNumerologyPage />} />
                <Route path="/analysis-result/:analysisId" element={<AnalysisResultPage />} />
                <Route path="/services" element={<HomePage />} />
                {/* Diğer analiz sayfaları buraya eklenecek */}
                <Route path="/synastry" element={<RelationshipNumerologyPage />} />
                <Route path="/future-numerology" element={<NumerologyPage />} />
                <Route path="/financial-numerology" element={<NumerologyPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
